import * as R from 'ramda';

const countryDropdown = (state: any) => R.pathOr([], ['UserProfile', 'countryDropdown'], state);
const getUserDetails = (state:any) => R.pathOr({}, ['UserProfile', 'getUserDetails'], state);
const getBranchValues = (state:any) => R.pathOr([], ['UserProfile', 'Branchvalues'], state);
const getResultMessage = (state:any) => R.pathOr(false, ['UserProfile', 'resultMessage'], state);
const UserProfileApps = (state:any) => R.pathOr({branchIds:[]}, ['UserProfile', 'UserProfileDetails'], state);
const externalUserData = (state:any) => R.pathOr([], ['UserProfile', 'externalUserData'], state);
const BranchList = (state: any) =>
  R.pathOr([], ["UserProfile", "BranchList"], state);


const selectors = {
    countryDropdown,
  getBranchValues,
  UserProfileApps,
  getResultMessage,
  getUserDetails,
  externalUserData,
  BranchList
}

export default selectors
